import dayjs from "dayjs";

/** 「今日 09:12」「昨日 18:30」「3 日前」「2026-09-01」。`now` は試験のため差し替え可。 */
export function relativeTime(iso: string, now: number = Date.now()): string {
  const t = dayjs.utc(iso).tz("Asia/Tokyo");
  if (!t.isValid()) return iso;
  const n = dayjs(now).tz("Asia/Tokyo");
  const sec = n.diff(t, "second");
  if (sec >= 0 && sec < 60) return "たった今";
  if (sec >= 0 && sec < 3600) return `${Math.floor(sec / 60)} 分前`;
  if (t.isSame(n, "day")) return `今日 ${t.format("HH:mm")}`;
  if (t.isSame(n.subtract(1, "day"), "day")) return `昨日 ${t.format("HH:mm")}`;
  const days = n.startOf("day").diff(t.startOf("day"), "day");
  if (days > 0 && days < 7) return `${days} 日前`;
  return t.format("YYYY-MM-DD");
}

/**
 * 期限の読み方。「期限まで 3 日」「今日が期限」「2 日超過」。
 * 日付だけ(`YYYY-MM-DD`)なら JST のその日として扱う。
 */
export function untilTime(iso: string, now: number = Date.now()): { text: string; over: boolean } {
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(iso);
  const t = dateOnly ? dayjs.tz(iso, "Asia/Tokyo") : dayjs.utc(iso).tz("Asia/Tokyo");
  if (!t.isValid()) return { text: iso, over: false };
  const n = dayjs(now).tz("Asia/Tokyo");
  const days = t.startOf("day").diff(n.startOf("day"), "day");
  if (days === 0) return { text: "今日が期限", over: false };
  if (days > 0) return { text: `期限まで ${days} 日`, over: false };
  return { text: `${-days} 日超過`, over: true };
}
